import { CSSProperties, FC, ReactNode } from "react";
import Text from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";
import TrashOutlineIcon from "@src/lib/icons/18px/trash-outline";

type Props = {
  avatar: ReactNode;
  title: string;
  subtitle: string;
  onClick: () => void;
  rowType?: "Card" | "Row";
  style?: CSSProperties;
  isDisabled?: boolean;
  showRemoveIcon?: boolean;
  rightAdornment?: ReactNode;
};

const LibraryItemRow: FC<Props> = ({
  avatar,
  title,
  subtitle,
  onClick,
  isDisabled = false,
  rowType = "Card",
  style,
  showRemoveIcon,
  rightAdornment,
}) => {
  return (
    <div
      onClick={() => {
        if (!isDisabled) {
          onClick();
        }
      }}
      className={cn(
        "px-2 py-1 flex items-center self-stretch",
        "cursor-pointer bg-white transition-colors duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)]",
        "hover:bg-gray-4-alpha",
        rowType === "Card" && "rounded-lg",
        rowType === "Row" && "border-b border-gray-5-alpha",
        isDisabled && "bg-gray-4-alpha cursor-auto",
      )}
      data-test-id="add-content-to-list-row"
      style={style}
    >
      {avatar}
      <div className="ml-2 flex flex-1 flex-col">
        <Text
          type="P3"
          fontWeight="Medium"
          className={cn(
            "self-stretch",
            isDisabled ? "text-gray-7" : "text-gray-12",
          )}
          ellipsis={true}
        >
          {title}
        </Text>
        <Text type="P3" className="text-gray-7">
          {subtitle}
        </Text>
      </div>
      {showRemoveIcon && <TrashOutlineIcon className="text-gray-5" />}
      {rightAdornment}
    </div>
  );
};

export default LibraryItemRow;
